import React from 'react';

interface FormErrorProps {
  /** The error message to display */
  message: string;
  /** Optional icon to display before the message */
  icon?: React.ReactNode;
  /** Optional className for additional styling */
  className?: string;
  /** Optional id for aria-describedby linking */
  id?: string;
}

const FormError: React.FC<FormErrorProps> = ({
  message,
  icon,
  className = '',
  id,
}) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '0.5rem',
    fontSize: '0.875rem',
    color: 'var(--danger, #dc3545)',
  };

  const iconStyle: React.CSSProperties = {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
  };

  return (
    <div
      id={id}
      role="alert"
      style={containerStyle}
      className={className}
    >
      {icon && <span style={iconStyle} aria-hidden="true">{icon}</span>}
      <span>{message}</span>
    </div>
  );
};

export default FormError;
